import * as React from 'react';
import './errorPage.scss';

type ErrorPageProps = {
  children?: any;
};

const ErrorPage = ({ children }: ErrorPageProps) => {
  if (!children) {
    children = 'An unexpected error has occurred';
  }
  return (
    <div className="plain error-page-wrapper cppw-error-page">
      <div>
        <div className="cppw-error-msg">{children}</div>
        <hr />
        <div className="cppw-error-ctx">
          <p>
            Go back to the previous page and try again. If you think something
            is broken, report a problem.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;

export const PageNotFound = () => <ErrorPage>404 Page Not Found.</ErrorPage>;

export const AccessDenied = () => <ErrorPage>Access Denied.</ErrorPage>;
